// extracted by mini-css-extract-plugin
export var label = "_i6-2";
export var slideContainer = "_i6-0";
export var slider = "_i6-1";